import styled, { css } from 'styled-components'

export type DatePickerTriggerProps = {
  $hasError?: boolean
  $hasValue?: boolean
}

export const DatePickerTrigger = styled.button<DatePickerTriggerProps>`
  min-width: ${({ theme: { layout } }) => layout.spacing(15)};
  min-height: ${({ theme: { layout } }) => layout.spacing(7)};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  padding: ${({ theme }) => `${theme.layout.spacing(1)} ${theme.layout.spacing(2)}`};
  background: ${({ theme }) => theme.colors.backgroundContent};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSize.default};
  line-height: 2;
  cursor: pointer;
  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${({ theme }) => theme.colors.error};
    `}
  ${({ $hasValue }) =>
    !$hasValue &&
    css`
      color: ${({ theme }) => theme.colors.disabled};
    `}

  &:disabled {
    border-color: ${({ theme }) => theme.colors.disabled};
    color: ${({ theme }) => theme.colors.disabled};
    cursor: default;
  }
`

export const DatePickerControlsWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DatePickerTriggerSeparator = styled.span`
  padding: ${({ theme }) => `${theme.layout.spacing(1)} ${theme.layout.spacing(2)}`};
  color: ${({ theme }) => theme.colors.disabled};
`
export const DatePickerCalendarWrapper = styled.div`
  z-index: 2000;
  box-shadow: 0 4px 4px 0 #0003;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.backgroundContent};

  .rdp-root {
    --rdp-day-width: 32px;
    --rdp-day-height: 32px;
    --rdp-day_button-width: 32px;
    --rdp-day_button-height: 32px;
    --rdp-nav_button-height: 32px;
    --rdp-nav_button-width: 32px;
    --rdp-accent-color: ${({ theme }) => theme.colors.active};
    --rdp-accent-color-dark: ${({ theme }) => theme.colors.backgroundActive};
    --rdp-range_start-background: ${({ theme }) => theme.colors.backgroundActive};
    --rdp-range_middle-background: ${({ theme }) => theme.colors.backgroundActive};
    --rdp-range_end-background: ${({ theme }) => theme.colors.backgroundActive};
    --rdp-outline: none;
    --rdp-outline-selected: none;
    --rdp-months-gap: none;
    --rdp-nav-height: none;
    --rdp-weekday-padding: none;
    --rdp-disabled-opacity: 0.25;
    margin: 0;
  }

  .rdp-month {
    margin: 0 !important;
    padding: ${({
      theme: {
        layout: { spacing },
      },
    }) => `${spacing(1.5)} ${spacing(4)} ${spacing(1.5)} ${spacing(3)}`};

    &:not(:last-of-type) {
      border-right: 1px solid ${({ theme }) => theme.colors.border};
    }
  }

  .rdp-months .rdp-nav {
    right: 20px;
    left: 12px;
    top: 8px;
    justify-content: space-between;
  }

  .rdp-selected {
    font-weight: unset;
    font-size: unset;
  }

  .rdp-caption_label {
    font-size: ${({ theme }) => theme.fontSize.small};
    line-height: 21px;
    padding: 0 0.25em;
    border: 2px solid transparent;
  }

  .rdp-nav svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }

  .rdp-nav button:not([aria-disabled='true']):hover {
    border-radius: 50%;
    color: #fff;
    fill: #fff;
    background-color: ${({ theme }) => theme.colors.active};
  }

  .rdp-month_caption {
    margin-bottom: ${({ theme }) => theme.layout.spacing(3)};
    justify-content: center;
  }

  .rdp-weekday {
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.small};
    line-height: 21px;
    height: 32px;
  }

  .rdp-week {
    padding: 4px 0;
  }

  .rdp-weeknumber,
  .rdp-day {
    font-size: ${({ theme }) => theme.fontSize.small};
    line-height: 32px;
  }

  .rdp-day_button:hover:not([disabled]) {
    border-color: transparent !important;
    border-radius: 50% !important;
    background-color: ${({ theme }) => theme.colors.active};
    color: ${({ theme }) => theme.colors.backgroundContent};
  }

  .rdp-day_today:not(.rdp-day_outside) {
    border: 1px solid ${({ theme }) => theme.colors.text};
    font-weight: 400;
  }

  .rdp-day_today.rdp-day_selected {
    border: none;
  }

  .rdp-range_middle {
    background-color: ${({ theme }) => theme.colors.backgroundActive};
    color: ${({ theme }) => theme.colors.text};
  }

  .rdp-root .rdp-range_start {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  .rdp-root .rdp-range_end {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }

  .rdp-row .rdp-day:last-child .rdp-range_middle {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }

  .rdp-row .rdp-day:first-child .rdp-range_middle {
    border-bottom-left-radius: 50%;
    border-top-left-radius: 50%;
  }
`
